import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgConversation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M40.106 19.458V3H3v37.543l9.745-9.743h7.148v16.456h27.362L57 57V19.458zM19.893 25.8h-9.219L8 28.472V8h27.106v11.458H19.893zM52 44.929l-2.674-2.673H24.893v-17.8H52z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M28.66 31.262h5v5h-5zm7.496 0h5v5h-5zm7.497 0h5v5h-5z",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConversation);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
